<template>
  <a-menu
    theme="dark"
    class="left-menu"
    mode="inline"
    :selectedKeys="[$store.state.selectedSubmenuId]"
    :style="{ height: '100%', borderRight: 0 }"
    :open-keys.sync="openKeys"
  >
    <a-sub-menu
      v-for="topMenu in $store.state.userMenu"
      :key="topMenu.menuId"
    >
      <span slot="title"><a-icon :type="topMenu.icon" /><span>{{ topMenu.menuName }}</span><a-badge v-if="topMenu.taskCount && topMenu.taskCount>0" :count="topMenu.taskCount" style="margin-left: 10px" /></span>
      <a-menu-item
        v-for="menuItem in topMenu.subMenus"
        :key="menuItem.menuId"
        v-if="!menuItem.subMenus"
        @click="onSubMenu(menuItem)"
      >
        {{ menuItem.menuName }} <a-badge v-if="menuItem.taskCount && menuItem.taskCount>0" :count="menuItem.taskCount" style="margin-left: 10px" />
      </a-menu-item>
    </a-sub-menu>
  </a-menu>
</template>

<script>
export default {
  data() {
    return {
      collapsed: false,
      openKeys: JSON.parse(localStorage.getItem("openKeys")),
      total: ""
    };
  },
  methods: {
    openSubmenu(menuId) {
      this.$store.dispatch("setCurTopMenuKey", menuId);
      for (let menu of this.$store.state.userMenu) {
        if (menu.menuId === menuId) {
          if (menu.path) {
            this.$store.dispatch("setCurSubMenuList", menu.subMenus);
            this.$router.push({ name: menu.path });
          } else if (menu.subMenus && menu.subMenus[0].path) {
            this.$store.dispatch("setCurSubMenuList", menu.subMenus);
            let path = menu.subMenus[0].path;
            if (path && path.includes(":")) {
              let name = path.split("#")[0];
              let tmpStr = path.split("#")[1];
              let value = tmpStr.split(":")[1];
              this.$router.push({ name: name, params: { type: value } });
            } else {
              this.$router.push({ name: path });
            }
          } else if (menu.subMenus && menu.subMenus[0].subMenus) {
            this.$store.dispatch("setCurSubMenuList", menu.subMenus);
            let path = menu.subMenus[0].subMenus[0].path;
            if (path && path.includes(":")) {
              let name = path.split("#")[0];
              let tmpStr = path.split("#")[1];
              let value = tmpStr.split(":")[1];
              this.$router.push({ name: name, params: { type: value } });
            } else {
              this.$router.push({ name: path });
            }
          }
          break;
        }
      }
    },
    onSubMenu(menu) {
      this.$store.dispatch("setCurSubMenu", menu.menuId);
      let path = menu.path;
      if (path && menu.path.includes(":")) {
        let name = path.split("#")[0];
        let tmpStr = path.split("#")[1];
        let value = tmpStr.split(":")[1];
        this.$router.replace({ name: name, params: { type: value } });
      } else {
        this.$router.push({ name: menu.path });
      }
    },
    splicingIconUrl(url) {
      return "iconfont " + url;
    }
  }
};
</script>
<style lang="less" scoped>
</style>
